angular.module('unica_invitation_group.invitation_group_controllers')

.controller('InvitationGroupAssignController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	InvitationListListService, UserListService,
	InvitationGroupAssignService, InvitationGroupEditService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.id       = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.searchData = {};

	$scope.clearSearch = function() {
		$scope.searchData = {
			event_id: $stateParams.event_id
		};
	};
	$scope.clearSearch();

	$scope.getInvitationGroup( $stateParams.id );
	// $scope.$on('invitation_group_loaded', function() {
	// 	console.log( $scope.invitationGroupData );
	// 	if ( $scope.invitationGroupData.filter ) {
	// 		$scope.searchData = JSON.parse( $scope.invitationGroupData.filter );
	// 	}
	// });



	$scope.loadInvitationLists = function()
	{
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsLists = data;
				}
			});
	};


	$scope.openImportInvitationsCFModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationsCFInstanceController2',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitations-cf-ca.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			if ( data.created.length > 0 ) {
				$scope.loadAssigns();
			}

		}, function () { });
	};



	$scope.loadAssigns = function()
	{
		$scope.showLoader();

		InvitationGroupAssignService
			.list( $stateParams.event_id, $stateParams.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationGroupEmails = data;
				}
			});
	};

	$scope.loadInvitationLists();
	$scope.loadAssigns();

	$scope.userList = [];
	$scope.advancedSearch = function()
	{
		$scope.showLoader();

		UserListService
			.advancedSearch( $scope.searchData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.userList = data;
				}
			});
	};

	var allUserChecked = false;
	$scope.toggleAllUsers = function() {
		allUserChecked = !allUserChecked;
		angular.forEach($scope.userList, function(user, key) {
			user.checked = ( allUserChecked ? true : false );
			$scope.userList[key] = user;
		});
		$scope.checkAllDisabled();
	};

	$scope.toggleUser = function(userId) {
		angular.forEach($scope.userList, function(user, key) {
			if ( user.id === userId ) {
				user.checked = !user.checked;
				$scope.userList[key] = user;
			}
		});
		$scope.checkAllDisabled();
	};

	$scope.inviteAllDisabled = true;
	$scope.checkAllDisabled = function() {
		$scope.inviteAllDisabled = true;
		angular.forEach($scope.userList, function(user, key) {
			if ( user.checked ) {
				$scope.inviteAllDisabled = false;
			}
		});
	};

	$scope.inviteUser = function( invitationId) {
		$scope.inviteSelectedUser( [ invitationId ] );
	};


	$scope.inviteSelectedUser = function(invitationIds)
	{
		if (!invitationIds) {
			invitationIds = [];
			angular.forEach($scope.userList, function(inv, key) {
				if ( inv.checked ) {
					invitationIds.push(inv.invitation_id);
				}
			});
		}

		$scope.showLoader();
		InvitationGroupAssignService
			.assign($stateParams.event_id, $stateParams.id, invitationIds )
			.then(function(data) {
				$scope.hideLoader();

				$scope._updateFilter();

				if ( data ) {
					$scope.showSuccessMsg( data + ' utenti aggiunti con successo!', '');
					$scope.loadAssigns();
				} else {
					$scope.showSuccessMsg( '0 utenti aggiunti con successo!', '');
				}
			});
	};

	$scope._updateFilter = function()
	{
		InvitationGroupEditService
			.updateFilter( $stateParams.id, $scope.searchData )
			.then(function(data) {
				$scope.clearSearch();
				$scope.userList = [];
			});
	};


	$scope.deleteInvitationGroupEmail = function( invitationGroupEmailId )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il destinatario?',
			text: 'Confermi la cancellazione del destinatario?'
		}).then(function() {

			$scope.showLoader();
			InvitationGroupAssignService
				.delete( invitationGroupEmailId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.invitationGroupEmails, function(invitationGroupEmail, key) {
							if ( invitationGroupEmail.id === invitationGroupEmailId ) {
								$scope.invitationGroupEmails.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Destinatario eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

})

	.controller('ModalImportInvitationsCFInstanceController2',
		function (
			$scope, $stateParams,
			$uibModalInstance, FileUploader, getBaseApiURL, Session
		) {

			$scope.importInvitationsData = {
				file: '',
				csv: ''
			};


			$scope.uploader = new FileUploader({
				removeAfterUpload: true,
				alias: 'csv',
				url: getBaseApiURL + '/import/assign-invitations-group/' + $stateParams.id,
				headers: {
					Authorization : 'Bearer ' + Session.token,
					Accept: 'application/json'
				}
			});


			$scope.uploader.onAfterAddingFile = function( fileItem ) {
				$scope.importInvitationsData.file = fileItem;
				$scope.importInvitationsData.csv = fileItem.file.name;
			};

			$scope.uploader.onCompleteItem = function(fileItem, response) {
				$scope.hideLoader();
				if ( response.result === 'ko' && response.message ) {
					$rootScope.showErrorMsg( response.message );
				} else {
					$scope.showSuccessMsg('Operazione completata');
				}
				$uibModalInstance.close( response );
			};

			$scope.deleteImportInvitationsCFCsv = function() {
				// angular.element(document.querySelector('.invitations_csv')).val(null);
				$scope.uploader.removeFromQueue( $scope.importInvitationsData.file );
				$scope.importInvitationsData.file = '';
				$scope.importInvitationsData.csv = '';
			};

			$scope.importInvitationsCF = function () {
				$scope.showLoader();
				$scope.uploader.uploadAll();
			};

			$scope.closeModal = function() {
				$uibModalInstance.dismiss('cancel');
			};

		});